import React, { useEffect, useState } from "react";
import Commend3Modal, {
  Commend3ModalInput,
  Commend3ModalLabel,
  Commend3PrimaryButton,
  Commend3SecondaryButton,
} from "./Commend3Modal";
import { Commend3Model } from "../Types";
import { RENAME_MODEL_TITLE } from "../Commend3Constants";

type RenameModelDialogProps = {
  model: Commend3Model | null;
  saving: boolean;
  onClose: () => void;
  onConfirm: (name: string) => void;
};

const RenameModelDialog = ({
  model,
  saving,
  onClose,
  onConfirm,
}: RenameModelDialogProps) => {
  const [name, setName] = useState<string>("");
  const [invalid, setInvalid] = useState<boolean>(false);

  useEffect(() => {
    if (model) {
      setName(model.name ?? "");
      setInvalid(false);
    }
  }, [model]);

  const trimmed = name.trim();

  const handleSave = () => {
    if (!trimmed) {
      setInvalid(true);
      return;
    }
    onConfirm(trimmed);
  };

  return (
    <Commend3Modal
      isOpen={Boolean(model)}
      title={RENAME_MODEL_TITLE}
      onClose={onClose}
      footer={
        <>
          <Commend3SecondaryButton
            id="commend3-rename-cancel"
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </Commend3SecondaryButton>
          <Commend3PrimaryButton
            id="commend3-rename-confirm"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? "Saving…" : "Rename"}
          </Commend3PrimaryButton>
        </>
      }
    >
      <div>
        <Commend3ModalLabel>Model name</Commend3ModalLabel>
        <Commend3ModalInput
          id="commend3-rename-name"
          value={name}
          invalid={invalid}
          disabled={saving}
          onChange={(next) => {
            setName(next);
            setInvalid(false);
          }}
        />
      </div>
    </Commend3Modal>
  );
};

export default RenameModelDialog;
